/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { useDataConnector } from '@forge/data-connector';
import React, { useState } from 'react';
import IComponentProps from '../useConnectorAndDynamicProps/IComponentProps';
import { v4 as uuid4 } from 'uuid';
import { getBearerTokenFromLS } from '../Utils/DataConnectorUtils';

export default function useConnectorForPost(props: IComponentProps) {
  const [newUuuid] = useState(uuid4());
  const requestHeader = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${getBearerTokenFromLS()}`,
    'X-SVCorId': newUuuid,
    ...props.requestContext.headers
  };

  const route = {
    rootnodes: props.requestContext.rootNodeId ?? '',
    nodes: props.requestContext.context.nodeId ?? '',
    sites: props.requestContext.context.siteId ?? ''
  };

  return useDataConnector(props.connectorConfig.name, {
    headers: requestHeader,
    route: route
  });
}
